<template>
  <div>
    <vs-button size="large" @click="selectButton('RESB');" style="height: 100px;" :color="btnColorResb"
      type="filled">RESB</vs-button>
    &nbsp;&nbsp;
    <vs-button size="large" @click="selectButton('REEM')" style="height: 100px;" :color="btnColorReem"
      type="filled">REEM</vs-button>

  </div>
</template>

<script>
export default {
  props: {
    defaultValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedValue: null,
      btnColorReem: 'gray',
      btnColorResb: 'gray',
    };
  },
  mounted() {
    this.selectedValue = this.defaultValue;
    this.selectButton(this.defaultValue);
  },
  methods: {
    selectButton(value) {
      if (value == 'REEM') {
        this.btnColorReem = 'primary';
        this.btnColorResb = 'gray';
      } else if (value == 'RESB') {
        this.btnColorReem = 'gray';
        this.btnColorResb = 'primary';
      }
      this.selectedValue = value;
    },
  },
  watch: {
    selectedValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
